import { CreateUserAccountLevel, RedditUsersListQuery, UserAccountLevel } from 'wb-reddit/graphql/generated';
import {
	ArrayElement, UserIcon, UserLock, isSpotify, KeyIcon,
} from '@aleph/shared-components';
import { UserAccountLevel as AuthGraphUserAccountLevel } from 'wb-spotify/graphql/authgraph/generated';

export type RedditUser = ArrayElement<RedditUsersListQuery['users']['items']>;

export const getRedditUserLevelName = (level: UserAccountLevel | CreateUserAccountLevel | AuthGraphUserAccountLevel) => {
	if (isSpotify()) {
		switch (level) {
			case AuthGraphUserAccountLevel.AdvertiserAdmin:
				return 'Advertiser administrator';
			case AuthGraphUserAccountLevel.PlatformAdmin:
				return 'Platform administrator';
			case AuthGraphUserAccountLevel.AgencyAdmin:
				return 'Agency administrator';
			case AuthGraphUserAccountLevel.User:
				return 'User';
		}

		return 'Unknown';
	}

	switch (level) {
		case UserAccountLevel.User:
		case CreateUserAccountLevel.User:
			return 'User';
		case UserAccountLevel.Admin:
		case CreateUserAccountLevel.Admin:
			return 'WB Administrator';
		case UserAccountLevel.Agency:
		case CreateUserAccountLevel.Agency:
			return 'Agency administrator';
		case UserAccountLevel.Advertiser:
		case CreateUserAccountLevel.Advertiser:
			return 'Advertiser administrator';
		case UserAccountLevel.ReadonlyUser:
		case CreateUserAccountLevel.ReadonlyUser:
			return 'Readonly user';
	}

	return 'Unknown';
};

const iconProps = {
	width:       16,
	height:      16,
	strokeWidth: 1.5,
};

export const getRedditUserLeveIcon = (level: UserAccountLevel | AuthGraphUserAccountLevel) => {
	if (isSpotify()) {
		switch (level) {
			case AuthGraphUserAccountLevel.AdvertiserAdmin:
				return <UserLock {...iconProps} />;
			case AuthGraphUserAccountLevel.PlatformAdmin:
				return <KeyIcon {...iconProps} />;
			case AuthGraphUserAccountLevel.User:
				return <UserIcon {...iconProps} />;
		}

		return <UserIcon {...iconProps} />;
	}

	switch (level) {
		case UserAccountLevel.User:
			return <UserIcon {...iconProps} />;
		case UserAccountLevel.Admin:
			return <KeyIcon {...iconProps} />;
		case UserAccountLevel.Agency:
		case UserAccountLevel.Advertiser:
			return <UserLock {...iconProps} />;
	}

	return <UserIcon {...iconProps} />;
};
